import { apiActionTypes } from '../../middleware';
const base = '@@Containers/AgencyDetails/';

export const UPLOAD_DOCUMENT = apiActionTypes(`${base}UPLOAD_DOCUMENT`);
export const DOWNLOAD_DOCUMENT = apiActionTypes(`${base}DOWNLOAD_DOCUMENT`);
export const DELETE_DOCUMENT = apiActionTypes(`${base}DELETE_DOCUMENT`);
export const REVERIFY_AGENCY_ADMIN = apiActionTypes(`${base}REVERIFY_AGENCY_ADMIN`);
export const DEACTIVATE_USER = apiActionTypes(`${base}DEACTIVATE_USER`);
